export default "__VITE_ASSET__DINOmxeJ__"